import React, { Component } from "react";
import { Modal, Input, Form, Select } from "antd";
import axios from "services/axios";

const FormItem = Form.Item;
const { TextArea } = Input;
const { Option } = Select;
const defaultPayload = {
  customerName: "",
  customerPhone: "",
  customerNIK: "",
  customerAddress: "",
  customerNPWP: "",
  paymentOption: "",
  salesType: "",
  countryName: "Indonesia",
  provinceId: null,
  cityId: null,
};

class ModalCreateSPK extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmLoading: false,
      payload: defaultPayload,
      provinces: [],
      cities: [],
      isDisableByCountry: false,
      isDisableByProvince: true,
    };
  }

  inputChange = (event) => {
    let { payload } = this.state;
    if (["customerPhone", "customerNIK"].includes(event.target.name)) {
      if (event.target.value != "") {
        let isNumber = /^\d+$/.test(event.target.value);
        if (!isNumber) return;
      }
    }

    this.setState({
      payload: {
        ...payload,
        [event.target.name]: event.target.value,
      },
    });
  };

  onChangeCountry(val) {
    let { payload } = this.state;
    let isDisableByCountry = false;
    if (val === "Luar Negeri") {
      isDisableByCountry = true;
      payload.provinceId = null;
      payload.cityId = null;
      payload.postalCode = null;
    }
    payload.countryName = val;
    this.setState({ payload, isDisableByCountry });
  }

  onChangeProvince(val) {
    this.fetchCities(val);
    this.setState({
      payload: {
        ...this.state.payload,
        provinceId: val,
        cityId: null,
      },

      isDisableByProvince: false,
    });
  }

  componentDidMount = () => {
    const { rawData } = this.props;
    this.fetchProvinces();

    if (rawData && rawData.customerName) {
      let customerPhone = rawData.customerPhone;
      if (customerPhone && customerPhone[0] == "6" && customerPhone[1] == "2") {
        customerPhone = customerPhone.slice(2, customerPhone.length);
      }
      console.log(customerPhone, "after");
      let payload = {
        customerName: rawData.customerName,
        customerPhone: customerPhone,
        customerNIK: rawData.customerNIK,
        customerAddress: rawData.customerAddress,
        customerNPWP: rawData.customerNPWP,
        paymentOption: rawData.paymentOption,
        salesType: rawData.salesType,
        countryName: rawData.countryName,
        provinceId: rawData.provinceId,
        cityId: rawData.cityId,
        postalCode: rawData.postalCode,
      };
      let isDisableByCountry = false;
      let isDisableByProvince = true;

      if (rawData.countryName == "Luar Negeri") isDisableByCountry = true;

      if (rawData.provinceId) {
        this.fetchCities(rawData.provinceId);
        isDisableByProvince = false;
      }
      this.setState({ payload, isDisableByCountry, isDisableByProvince });
    }
  };

  fetchProvinces = async () => {
    let {
      data: { provinces },
    } = await axios.get(`/provinces`);
    this.setState({ provinces });
  };

  fetchCities = async (provinceId) => {
    let {
      data: { cities },
    } = await axios.get(`/cities/province/${provinceId}`);
    this.setState({ cities });
  };

  render() {
    const {
      confirmLoading,
      payload,
      provinces,
      cities,
      isDisableByCountry,
      isDisableByProvince,
    } = this.state;
    const { toggleShowModal, showModal, handleAction, rawData } = this.props;
    console.log(rawData, "raw ata render");
    return (
      <Modal
        title="Create SPK"
        visible={showModal}
        confirmLoading={confirmLoading}
        okText={"Submit"}
        onOk={() => handleAction(payload)}
        onCancel={() => toggleShowModal(false)}
        width={450}>
        <FormItem label="Customer Name" style={{ marginBottom: 5 }}>
          <Input
            placeholder={"Your name"}
            name={"customerName"}
            defaultValue={payload.customerName}
            onChange={(event) => this.inputChange(event)}
          />
        </FormItem>
        <FormItem label="Sales Type" style={{ marginBottom: 5 }}>
          <Select
            style={{ width: "100%" }}
            placeholder="Select a sales type"
            defaultValue={payload.salesType}
            onChange={(value) =>
              this.setState({ payload: { ...payload, salesType: value } })
            }>
            {/* {rawData && rawData.productType !== "Operational" ? ( */}
            <Option value={"B2B"}>B2B</Option>
            {/* ) : null} */}
            {/* {rawData && rawData.productType !== "Operational" ? ( */}
            <Option value={"B2C"}>B2C</Option>
            {/* ) : null} */}
            <Option value={"Operational"}>Operational</Option>
          </Select>
        </FormItem>
        <FormItem label="Payment Option" style={{ marginBottom: 5 }}>
          <Select
            style={{ width: "100%" }}
            placeholder="Select a payment option"
            defaultValue={payload.paymentOption}
            onChange={(value) =>
              this.setState({ payload: { ...payload, paymentOption: value } })
            }>
            <Option value={"Full Payment"}>Full Payment</Option>
            <Option value={"Leasing"}>Leasing</Option>
          </Select>
        </FormItem>
        <FormItem label="Mobile Phone" style={{ marginBottom: 5 }}>
          <div style={{ display: "flex" }}>
            <div
              style={{
                padding: 10,
                backgroundColor: "#f5f5f5",
                borderRadius: "5px 0px 0px 5px",
              }}>
              +62
            </div>
            <Input
              placeholder={"81234567890"}
              style={{
                border: "1px solid #d9d9d9",
                borderRadius: "0px 5px 5px 0px",
              }}
              name={"customerPhone"}
              defaultValue={payload.customerPhone}
              value={payload.customerPhone}
              onChange={(event) => this.inputChange(event)}
            />
          </div>
        </FormItem>
        <FormItem label="NIK" style={{ marginBottom: 5 }}>
          <Input
            placeholder={"1234567890"}
            name={"customerNIK"}
            value={payload.customerNIK}
            onChange={(event) => this.inputChange(event)}
          />
        </FormItem>
        <FormItem label="NPWP" style={{ marginBottom: 5 }}>
          <Input
            placeholder={"123456789"}
            name={"customerNPWP"}
            value={payload.customerNPWP}
            onChange={(event) => this.inputChange(event)}
          />
          <h5 style={{ marginTop: 5 }}>(Optional)</h5>
        </FormItem>

        {/* Country */}
        <FormItem label="Country" style={{ marginBottom: 5 }}>
          <Select
            style={{ width: "100%" }}
            placeholder="Select a country"
            defaultValue={payload.countryName}
            onChange={(value) => this.onChangeCountry(value)}>
            <Option value={"Indonesia"}>Indonesia</Option>
            <Option value={"Luar Negeri"}>Luar Negeri</Option>
          </Select>
        </FormItem>

        {/* Province */}
        <FormItem label="Province" style={{ marginBottom: 5 }}>
          <Select
            style={{ width: "100%" }}
            placeholder="Select a province"
            defaultValue={payload.provinceId}
            value={payload.provinceId}
            disabled={isDisableByCountry}
            onChange={(value) => this.onChangeProvince(value)}>
            {provinces &&
              provinces.map((province) => (
                <Option value={province.id}>{province.name}</Option>
              ))}
          </Select>
        </FormItem>

        {/* Province */}
        <FormItem label="City" style={{ marginBottom: 5 }}>
          <Select
            style={{ width: "100%" }}
            placeholder="Select a city"
            defaultValue={payload.cityId}
            value={payload.cityId}
            disabled={isDisableByCountry || isDisableByProvince}
            onChange={(value) =>
              this.setState({ payload: { ...payload, cityId: value } })
            }>
            {cities &&
              cities.map((city) => (
                <Option value={city.id}>{city.name}</Option>
              ))}
          </Select>
        </FormItem>

        {/* City */}
        <FormItem label="Postal Code" style={{ marginBottom: 5 }}>
          <Input
            placeholder={"Postal Code ..."}
            name={"postalCode"}
            value={payload.postalCode}
            disabled={isDisableByCountry}
            onChange={(event) => this.inputChange(event)}
          />
          <h5 style={{ marginTop: 2 }}>(Optional)</h5>
        </FormItem>

        {/* Alamat */}
        <FormItem label="Alamat" style={{ marginBottom: 5 }}>
          <TextArea
            placeholder={"Jalan ...."}
            name={"customerAddress"}
            value={payload.customerAddress}
            onChange={(event) => this.inputChange(event)}
          />
          <h5 style={{ marginTop: 2 }}>(Optional)</h5>
        </FormItem>
      </Modal>
    );
  }
}

export default ModalCreateSPK;



// WEBPACK FOOTER //
// src/components/Dashboard/EApproval/Modal/ModalCreateSPK.js